/**
 * Simple plain-text to HTML formatter for blog content.
 * Supports:
 *   - Paragraphs (double newline)
 *   - Line breaks (single newline)
 *   - Bold: **text** or __text__
 *   - Italic: *text* or _text_
 *   - Bullet lists: lines starting with "- " or "* "
 */
export function formatBlogContent(text) {
  if (!text) return '';

  let html = text;

  // Escape HTML entities to prevent injection
  html = html
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  // Convert bold: **text** or __text__
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/__(.+?)__/g, '<strong>$1</strong>');

  // Convert italic: *text* or _text_ (but not inside bold)
  html = html.replace(/(^|[^*])\*(.+?)\*(?![*])/g, '$1<em>$2</em>');
  html = html.replace(/(^|[^_])_(.+?)_(?!_)/g, '$1<em>$2</em>');

  // Split into lines for list processing
  const lines = html.split('\n');
  const result = [];
  let inList = false;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const listMatch = line.match(/^(\s*)[-*]\s+(.*)$/);

    if (listMatch) {
      if (!inList) {
        result.push('<ul>');
        inList = true;
      }
      result.push(`<li>${listMatch[2]}</li>`);
    } else {
      if (inList) {
        result.push('</ul>');
        inList = false;
      }
      result.push(line);
    }
  }

  if (inList) {
    result.push('</ul>');
  }

  html = result.join('\n');

  // Wrap non-empty, non-list lines in <p> tags
  // First split by double newlines to create paragraphs
  const paragraphs = html.split(/\n{2,}/);
  html = paragraphs
    .map((p) => {
      const trimmed = p.trim();
      if (!trimmed) return '';
      // If it's already a list, don't wrap in <p>
      if (trimmed.startsWith('<ul>')) return trimmed;
      // Replace single newlines with <br>
      const withBreaks = trimmed.replace(/\n/g, '<br>');
      return `<p>${withBreaks}</p>`;
    })
    .filter((p) => p)
    .join('\n');

  return html;
}
